import { combineReducers } from "redux";
import commentLibrary from "./CommentLibraryReducer";
import templates from "./TemplateReducer";
import globalList from "./GlobalListReducer";

const createReducer = (asyncReducers) => {
  const appReducer = combineReducers({
    commentLibrary,
    templates,
    globalList,
    ...asyncReducers,
  });
  return (state, action) => {
    return appReducer(state, action);
  };
};

export default createReducer;
